exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".modal-custom .modal-content .close-btn {\n    background: #F1F8FD;\n    box-shadow: inset 0px -1px 0.5px rgba(14, 14, 44, 0.4);\n    border-radius: 8px;\n    position: absolute;\n    font-size: 25px;\n    top: 28px !important;\n    right: 32px !important;\n    padding: 4px;\n    width: 32px;\n    height: 32px;\n    color: var(--primary);\n    opacity: 1;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/application/core-module/scora-modal-module/learning-support-modal/learning-support-modal.component.css
// module id = 846
// module chunks = 6